<template>
  <keep-alive>
    <top-navbar :currentRoute="$route" :filter="true" :createBtn="true" @openModalFilter="openModalFilter" @createElement="createElement"></top-navbar>
  </keep-alive>
  <section id="reports" class="container-content">
    <div class="container-tablist">
      <div class="tablist">
        <div :class="[activeTab === 'kredit' ? 'active tab' : 'tab']" @click="changeTab('kredit')">
          <span>Кредит</span>
          <div class="tab-border-bottom"></div>
        </div>
        <div :class="[activeTab === 'term' ? 'active tab' : 'tab']" @click="changeTab('term')">
          <span>Сроки оплат</span>
          <div class="tab-border-bottom"></div>
        </div>
        <div :class="[activeTab === 'shipment' ? 'active tab' : 'tab']" @click="changeTab('shipment')">
          <span>Отгрузки</span>
          <div class="tab-border-bottom"></div>
        </div>
        <div :class="[activeTab === 'quota' ? 'active tab' : 'tab']" @click="changeTab('quota')">
          <span>Квоты</span>
          <div class="tab-border-bottom"></div>
        </div>
      </div>
    </div>
    <div class="scrollable-table-container">
      <table class="orders">
        <tr class="row-title">
          <!-- Выбор заголовков -->

          <th v-for="(header, index) in headers" :key="header">
            <div class="flex-between-block th-width pointer" @click="selectSortField(index)">
              {{ header }}
              <span class="wd-sort-i">
                <!-- <img v-show="sortField == index && (sortASC || sortDESC)" src="@/assets/img/sorting.svg" /> -->
                <mdicon v-show="sortField == index && (sortASC == index || sortDESC == index)" name="swap-vertical" width="18" height="16"></mdicon>
              </span>
            </div>
          </th>
        </tr>
        <tr v-for="order in data" :key="order">
          <td v-for="(header, index) in headers" :key="header" :class="getCellClass(index)">
            <!-- <span v-if="index == 'status'" :class="getOrderClass(order[index])">{{ getOrderStatus(order[index]) }}</span> -->
            <span v-if="index == 'status'" :class="getOrderClass(order[index])">{{ order[index] }}</span>
            <span v-else-if="index == 'typePrice'" :class="getOrderPriceClass(order[index])">{{ getOrderPrice(order[index]) }}</span>
            <span v-else>{{ order[index] }}</span>
          </td>
        </tr>
      </table>
      
    </div>

    <div class="scrollable-table-container" style="margin-top: 50px;">
      <table class="orders">
        <tr class="row-title">
          <!-- Выбор заголовков -->

          <th v-for="(header, index) in headers1" :key="header">
            <div class="flex-between-block th-width pointer" @click="selectSortField(index)">
              {{ header }}
              <span class="wd-sort-i">
                <!-- <img v-show="sortField == index && (sortASC || sortDESC)" src="@/assets/img/sorting.svg" /> -->
                <mdicon v-show="sortField == index && (sortASC == index || sortDESC == index)" name="swap-vertical" width="18" height="16"></mdicon>
              </span>
            </div>
          </th>
        </tr>
        <tr v-for="order in data1" :key="order">
          <td v-for="(header, index) in headers1" :key="header" :class="getCellClass(index)">
            <!-- <span v-if="index == 'status'" :class="getOrderClass(order[index])">{{ getOrderStatus(order[index]) }}</span> -->
            <span v-if="index == 'status'" :class="getOrderClass(order[index])">{{ order[index] }}</span>
            <span v-else-if="index == 'typePrice'" :class="getOrderPriceClass(order[index])">{{ getOrderPrice(order[index]) }}</span>
            <span v-else>{{ order[index] }}</span>
          </td>
        </tr>
      </table>
      
    </div>
  </section>
</template>

<script>
import TopNavbar from "../components/TopNavbar.vue";
export default {
  name: 'ReportsPage',
  components: {
    TopNavbar
  },
  data() {
    return {
      sortASC: "",
      sortDESC: "",
      sortField: "",
      selectedFields: [],
      activeTab: 'kredit',
      headers: {},
      headers1: {},
      headers2: {},
      data: [],
      data1: [],
      defaultData: [],
      showModalFields: false,
      showModalFilter: false
    }
  },
  mounted() {
    console.log(this.$route)
    this.init();
  },
  watch: {
    activeTab() {
      this.init()
    }
  },
  methods: {

    // Инициализация
    init() {
      this.sortASC = ""
      this.sortDESC = ""
      this.sortField = ""

      //Заполнить массив в зависимости от выбранной вкладки
      if (this.activeTab == "kredit") {
        this.headers = {
          days: "Дни отсрочки", 
          prepayment: "Предоплата", 
          kredit: "Кредит", 
          have: "Использовано", 
          free: "Свободно", 
        };
        this.headers1 = {
          num: "Реализация", 
          date: "Дата реализации", 
          date1: "Дата отгрузки", 
          summ: "Сумма",
        };

        this.data = [
          {
            days: "30", 
            prepayment: "0", 
            kredit: "1 000 000,00", 
            have: "909 000,00", 
            free: "91 000,00"
          }
        ]
        this.data1 = [
          {
            num: "20039232090", 
            date: "01.11.2024", 
            date1: "21.11.2024", 
            summ: "240 000, 00",
          },
          {
            num: "20039232091", 
            date: "01.11.2024", 
            date1: "21.11.2024", 
            summ: "910 000, 00",
          },
          {
            num: "20039232092", 
            date: "01.11.2024", 
            date1: "21.11.2024", 
            summ: "250 000, 00",
          },
        ]
      }
      else {
        this.headers ={
          zadolzh: "Дебиторская задолженность", 
          summ: "", 
        };

        this.headers1 ={
          num: "№ Заказа", 
          date1: "Дата отгрузки", 
          date2: "Дата оплаты", 
          summ: "Сумма", 
        };

        this.data = [
          {
            zadolzh: "Просрочено", 
            summ: "476 000, 00", 
          },
          {
            zadolzh: "К оплате в ближайшие 7 дней", 
            summ: "1 000 000, 00", 
          },
          {
            zadolzh: "Предоплата", 
            summ: "0", 
          },
        ]

        this.data1 = [
          {
            num: "20039232090", 
            date1: "01.11.2024", 
            date2: "28.10.2024", 
            summ: "Сумма",
          },
        ]
      }
      // Получим заказы в data
      console.log(this.data);
      // клон
      this.defaultData = JSON.parse(JSON.stringify(this.data))
    },

    // Выбор активной табы
    changeTab(tabName) {
      this.activeTab = tabName;
    },

    // Удалить фильтр по полю
    delFilter() {
      alert("Удаляем фильтр по полю");
    },

    // Определение класса для типов ячеек
    getCellClass(name) {
      if(name == "status") return "cell-status"
      else if(name == "typePrice") return "cell-price"
      else return ""
    },

    // Определение названий для ячеек статуса
    // getOrderClass(name) {
    //   if(name == "working") return "working"
    //   else if(name == "shipped") return "shipped"
    //   else if(name == "draft") return "draft"
    //   else if(name == "cancel") return "cancel"
    //   else if(name == "processingSupplier") return "processingSupplier"
    //   else if(name == "processingClient") return "processingClient"
    //   else return "default-status"
    // },
    getOrderClass(name) {
      if(name == "В работе") return "working"
      else if(name == "Отгружен") return "shipped"
      else if(name == "Черновик") return "draft"
      else if(name == "Отменен") return "cancel"
      else if(name == "Согласование (Поставщик)") return "processingSupplier"
      else if(name == "Согласование (Клиент)") return "processingClient"
      else return "default-status"
    },

    // Определение классов для ячеек статуса
    // getOrderStatus(name) {
    //   if(name == "working") return "В работе"
    //   else if(name == "shipped") return "Отгружен"
    //   else if(name == "draft") return "Черновик"
    //   else if(name == "cancel") return "Отменен"
    //   else if(name == "processingSupplier") return "Согласование (Поставщик)"
    //   else if(name == "processingClient") return "Согласование (Клиент)"
    //   else return ""
    // },

    // Определение названий для ячеек типа цены
    getOrderPrice(name) {
      if(name == "price") return "Прайс-лист"
      else if(name == "kp") return "КП"
      else return ""
    },
    // Определение классов для ячеек типа цены
    getOrderPriceClass(name) {
      if(name == "price") return "price-type"
      else if(name == "kp") return "kp-type"
      else return ""
    },

    // Закрыть модалку
    closeModal() {
      this.showModalFields = false;
      this.showModalFilter = false;
    },

    // Выбор поля для сортировки
    selectSortField(field) {
      console.log(this.defaultData)
      this.sortField = field
      if(this.sortASC != field && this.sortDESC != field) {
        this.sortASC = field
        this.data.sort(function(a, b) {
          const fieldA = a[field].toLowerCase();
          const fieldB = b[field].toLowerCase();

          if (fieldA < fieldB)  return -1;
          if (fieldA > fieldB)  return 1;
          else  return 0;
        });
      }
      else if(this.sortASC == field) {
        this.sortASC = ""
        this.sortDESC = field
        this.data.sort(function(a, b) {
          const fieldA = a[field].toLowerCase();
          const fieldB = b[field].toLowerCase();

          if (fieldA > fieldB)  return -1;
          if (fieldA < fieldB)  return 1;
          else  return 0;
        });
      }
      else if(this.sortDESC == field) {
        this.sortDESC = ""
        this.data = JSON.parse(JSON.stringify(this.defaultData))
      }
    },
    // Открыть модалку для фильтрации
    openModalFilter() {
      this.showModalFilter = true
    },

    // Создать заказ
    createElement() {
      this.$router.push('/order/create');
    }
  }
}
</script>
